import EdContextMenuContainer from './components/ed-context-menu/ed-context-menu.vue';
import { EdContextMenuModel } from './models/ed-context-menu.model';
import { EdContextMenuOptionsModel } from './models/ed-context-menu-options.model';
import { ED_CONTEXT_MENU_EVENTS, ED_CONTEXT_MENU_TYPES } from './ed-context-menu.values';

const ED_CONTEXT_MENU = {
  EVENTS: ED_CONTEXT_MENU_EVENTS,
  TYPES: ED_CONTEXT_MENU_TYPES
};

const EdContextMenu = {
  install: (Vue) => {

    /* Components */
    Vue.component('ed-context-menu', EdContextMenuContainer);

    /* Settings */
    Vue.prototype.$EdContextMenu = new Vue({
      methods: {
        show(params = new EdContextMenuModel({})) {
          return new Promise((resolve) => {
            this.$EdContextMenu.$emit(ED_CONTEXT_MENU.EVENTS.SHOW_CONTEXT_MENU, {
              params,
              cb: (optionSelected = new EdContextMenuOptionsModel({})) => {
                resolve(optionSelected);
              }
            });
          });
        },
        createBlank({position = {x: 0, y: 0}, comp = {}, className = '', params = {}, offsetX = 0}) {
          this.$EdContextMenu.$emit(ED_CONTEXT_MENU.EVENTS.SHOW_CONTEXT_MENU, {
            params: {
              position,
              type: ED_CONTEXT_MENU.TYPES.BLANK,
              options: {
                comp,
                params
              },
              offsetX: offsetX,
              className: className
            }
          });
        },
        close() {
          this.$EdContextMenu.$emit(ED_CONTEXT_MENU.EVENTS.CLOSE_CONTEXT_MENU);
        },
        updateOptions(options) {
          this.$EdContextMenu.$emit(ED_CONTEXT_MENU.EVENTS.UPDATE_OPTIONS_CONTEXT_MENU, options);
        }
      }
    });

  }
}

export {
  EdContextMenu,
  ED_CONTEXT_MENU,
  EdContextMenuModel,
  EdContextMenuOptionsModel
};
